import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-1821">
      <div className="flex min-h-screen items-center justify-center p-4" data-id="element-1822">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} data-id="element-1823" />
        <div className={`relative bg-white rounded-lg shadow-xl ${sizeClasses[size]} w-full`} data-id="element-1824">
          <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-1825">
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-1826">{title}</h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1827">
              <X className="h-5 w-5" data-id="element-1828" />
            </button>
          </div>
          <div className="p-6" data-id="element-1829">{children}</div>
        </div>
      </div>
    </div>;
}